$(document).ready(function(){
	$(".out_message_create").on("click",function(){
		attr = this.id.split("_")	;
		attributes	=	{}			;
		attributes["message_id"]			=	attr[0]		;
		attributes["message_type"]			=	attr[1]		;
		
		attributes["name"]					=	attr[2]		;
		attributes["out_message_type"]		=	"WHATSAPP"	;
		attributes["content"]				=	""			;
		
		var path = "/out_messages";
		$.ajax({	url: 		path,
					type: 		"post",
					data: 		{out_message : attributes},
					dataType: 	"json", 
					success: 	function(result){	},
	    			error: 		function (jqXHR, text, errorThrown) {	alert(jqXHR.responseJSON.error);	}
    			});
    
	});
});